import { EventViewData } from 'components/eventView/pages/eventData';

export const ZaKarierou2024Event: EventViewData = {
    eventId: 'zakarierou',
    mapId: '1cca7b1f-6456-410a-8aa9-ab623fdbd00b',
    guideId: '873247cd-bbe0-4784-9ebb-54344dbeb9de',
    mapSettings: {
        standZoom: 0.6
    }
};
